import { TABS_ENUM, VALIDATE_MESSAGES } from './constants'
import { cloneDeep, set } from 'lodash'
import { validateValue } from '../../../../../../common/utils/validator'

export const updateValidateRules = (structure, validateRules, activeTabId) => {
    const rules = cloneDeep(validateRules)
    Object.entries(TABS_ENUM).forEach(([key, value]) => {
        if (activeTabId && value !== activeTabId) {
            delete rules[key]
        }
    })
    return rules
}

export const validateFields = (structure, validateRules, initValidateStructure) => {
    const validateErrors = cloneDeep(initValidateStructure)
    for (const viewKey of Object.keys(structure)) {
        const view = structure[viewKey]
        if (!validateRules[viewKey]) {
            continue
        }
        for (const fieldKey of Object.keys(view)) {
            const value = view[fieldKey]
            const rules = validateRules[viewKey][fieldKey]
            const errorMessages = rules
                ? rules.filter(rule => !validateValue(rule, value)).map(rule => VALIDATE_MESSAGES[rule])
                : []

            if (errorMessages.length) {
                set(validateErrors, `${viewKey}.${fieldKey}`, errorMessages)
                set(validateErrors, 'hasError', true)
            }
        }
    }

    return validateErrors
}
